<style>
  .selection {
    position: absolute;
    border: 1px solid #37b78c;
    background-color: rgba(55, 183, 140, 0.4);
    z-index: 1;
    top: 0;
    left: 0;
    cursor: default;
    display: none;
  }

  .selectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .selected img {
    outline: 2px solid #00422c;
  }

  .selected .custom-checkbox label:before {
    background-color: #37b78c;
  }

  .selected .custom-checkbox label:after {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
  }

  .custom-control-label {
    z-index: 2;
    margin-right: 15px;
  }
</style>

<template>
  <div class="cut-dossie">
    <div class="row">
      <div class="col-8">
        <p class="content-heading pt-0">
          <i class="si si-arrow-left"></i> <span class="h3">Dossiês Digitalizados</span>
          <router-link :to="'/scanned/'" class="btn btn-dark btn-lg float-right shadow-sm text-uppercase">
            <i class="fa fa-arrow-left mr-10"></i> Voltar
          </router-link>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 left-content">
        <div class="block block-rounded shadow-sm pb-10 block-thumbails">
          <div class="block-header">
            <h3 class="block-title">
              <strong>Recortes Pendentes</strong>
            </h3>
          </div>
          <div class="block-content" v-if="!loading.pagesPdf && slices[selectedJob].jobCategoryPages.length > 0">
            <div class="row">
              <div class="col-12 px-0">
                <div v-selectable="{ selectedGetter, selectedSetter, selectingSetter }" class="container" id="vsel">
                  <div class="row">
                    <div v-for="(item, i) in slices[selectedJob].jobCategoryPages" :key="i"
                         class=" col-sm-6 col-xl-3 mb-30 card-thumb" :class="{ selected: !!selected[i], selecting: !!selecting[i] }">
                      <img width="200" :src="item.thumb"
                           alt="Pdf thumbnail"
                           class="selectable img-fluid shadow" draggable="false">

                      <div class="form-group">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input title="check" class="custom-control-input" type="checkbox">
                          <label class="custom-control-label"></label>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="zoom-content text-center">
                          <button @click="zoomImg(i)" data-toggle="modal"
                                  data-target="#modalZoomImg"
                                  class="btn btn-alt-primary btn-md px-4 mx-2 text-uppercase my-5">
                            <i class="fa fa-search-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="selection-area" class="selection"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="!loading.pagesPdf && slices[selectedJob].jobCategoryPages.length === 0">
            <h5 class="text-center">Nenhum dossiê digitalizado.</h5>
          </div>
          <div v-else>
            <h2 class="text-center"><i class="fa fa-spinner fa-spin"></i></h2>
          </div>
        </div>
        <div class="block block-rounded shadow-sm pb-10 block-group">
          <div class="block-header">
            <h3 class="block-title"><strong>Classificações Realizadas</strong></h3>
          </div>
          <div class="block-content pt-0 pb-20" data-toggle="slimscroll" data-height="160px"
               data-color="#37b78c" data-opacity="1" data-size="8px" data-always-visible="true"
               data-rail-visible="true" data-rail-color="#eee" data-rail-opacity="1"
               v-if="!loading.slicesCategory">
            <div class="row">
              <div class="col-md-3 mt-4" v-for="(item,i) in slices" :key="i">
                <button type="button" class="btn btn-block y-3 text-left btn-outline-primary"
                        v-bind:title="item.category" @click="selectJob(i)"
                        v-bind:class="{'btn-outline-success': slices[i].send && slices[i].received, 'btn-outline-warning': !slices[i].send && slices[i].received, 'btn-outline-danger': !slices[i].received , 'active': classJob[i].selec}">
                  <i class="fa mr-5"
                     v-bind:class="{'fa-check-circle' : slices[i].send && slices[i].received, 'fa-upload': !slices[i].send && slices[i].received, 'fa-times-circle': !slices[i].received}"></i>
                  <span class="text-black">{{ item.category }}</span>
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <h2 class="text-center"><i class="fa fa-spinner fa-spin"></i></h2>
          </div>
        </div>
      </div>
      <div class="col-md-4 right-content">
        <div class="block block-rounded shadow bg-primary student-data">
          <div class="block-header">
            <h4 class="block-title text-center text-white">Dados do aluno</h4>
          </div>
          <div v-if="!loading.studentDetail">
            <div class="block-content">
              <p class="text-white"><i class="fa fa-file-text-o mr-10"></i><strong>Número da
                Matrícula:</strong> {{student.registration}}</p>
              <p class="text-white"><i class="fa fa-user mr-10"></i><strong>Nome:</strong> {{student.name}}
              </p>
              <p class="text-white"><i class="fa fa-building mr-10"></i><strong>Unidade:</strong>
                {{student.unity}}</p>
              <p class="text-white"><i class="fa fa-graduation-cap mr-1"></i><strong>Curso:</strong>
                {{student.course}}</p>
            </div>
          </div>
          <div v-else>
            <h2 class="text-center text-white"><i class="fa fa-spinner fa-spin"></i></h2>
          </div>
        </div>
        <div class="block block-themed block-rounded shadow actions-content">
            <div class="block-header bg-gd-emerald shadow">
                <h4 class="block-title text-center text-white">Ações / Classificação</h4>
            </div>
            <div class="block-content bg-primary">
                <div class="row">
                    <form action="" method="post" onsubmit="return false;" class="col-12">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" for="classification-code"><b>Assunto</b></label>
                            <div class="col-md-12">
                                <input type="text" class="form-control" id="classification-code" ref="subject" v-model="subject" v-validate="{required: true}">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <form action="" method="post" onsubmit="return false;" class="col-12">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" for="classification-code"><b>Autor</b></label>
                            <div class="col-md-12">
                                <input type="text" class="form-control" id="classification-code" ref="author" v-model="author" v-validate="{required: true}">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <form action="" method="post" onsubmit="return false;" class="col-12">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" for="classification-code"><b>Local/Data/Hora</b></label>
                            <div class="col-md-12">
                                <input type="text" class="form-control" id="classification-code" ref="locationDateTime" v-model="locationDateTime" v-validate="{required: true}" readonly>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <form action="" method="post" onsubmit="return false;" class="col-12">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" for="classification-code"><b>Responsável Digitalização</b></label>
                            <div class="col-md-12">
                                <input type="text" class="form-control" id="classification-code" ref="digitizationResponsible" v-model="digitizationResponsible" v-validate="{required: true}">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <form action="" method="post" onsubmit="return false;" class="col-12">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" for="classification-code"><b>Data de Produção</b></label>
                            <div class="col-md-12">
                                <input type="text" class="form-control" id="classification-code" ref="productionDate" v-model="productionDate" v-validate="{required: true}" placeholder="dd/mm/aaaa" v-mask="'##/##/####'">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <form action="" method="post" onsubmit="return false;" class="col-12">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" for="classification-code"><b>Gênero</b></label>
                            <div class="col-md-12">
                                <v-select ref="genus" v-model="genus" :options="listGenus" :selected="genus">
                                </v-select>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="aditionalFields bg-primary"
                 v-if="loading.additionalFields && slices[selectedJob].additionalFields.length > 0">
                <div class="block-header rounded-0 px-0">
                    <h4 class="block-title bg-green-title py-5 px-15 text-dark text-center">Campos adicionais</h4>
                </div>
                <div class="block-content bg-primary pt-0">
                    <div v-for="(e, i) in slices[selectedJob].additionalFields" :key="i">
                        <div class="form-group row">
                            <label class="col-12 col-form-label text-white" :for="'field'+i">
                                <b>{{ e.name }}</b>
                            </label>
                            <div class="col-12">
                                <input :ref="'identificador'+i" v-if="e.type==='string'" type="text"
                                       :data-vv-as="e.name" :name="e.name.toString()"
                                       class="form-control" :id="'field'+i"
                                       v-model="slices[selectedJob].additionalFields[i].value"
                                       v-validate="{required:e.required}">
                                <input :ref="'identificador'+i" v-if="e.type==='datetime'" type="text"
                                       :data-vv-as="e.name" :name="e.name.toString()"
                                       class="form-control u-full-width" :id="'field'+i"
                                       placeholder="dd/mm/aaaa" v-mask="'##/##/####'"
                                       v-model="slices[selectedJob].additionalFields[i].value"
                                       v-validate="{required:e.required,date_format:'DD/MM/YYYY'}" />
                                <div v-if="e.type==='bool'">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" :id="'yes_field'+i" :data-vv-as="e.name"
                                               :name="e.name.toString()"
                                               class="custom-control-input" value="SIM"
                                               v-model="slices[selectedJob].additionalFields[i].value"
                                               v-validate="{required:e.required,included: ['SIM','NÃO']}">
                                        <label class="custom-control-label text-white"
                                               :for="'yes_field'+i"><strong>Sim</strong></label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" :id="'no_field'+i" :data-vv-as="e.name"
                                               :name="e.name.toString()"
                                               class="custom-control-input" value="NÃO"
                                               v-model="slices[selectedJob].additionalFields[i].value">
                                        <label class="custom-control-label text-white"
                                               :for="'no_field'+i"><strong>Não</strong></label>
                                    </div>
                                </div>
                                <span class="text-danger-light">{{ errors.first(e.name.toString()) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-content bg-primary pt-30 pb-10">
                <div class="form-group row" v-if="!loading.slicesCategory">
                    <div class="col-12 pt-20">
                        <button type="button" class="btn btn-alt-primary btn-lg btn-block text-uppercase"
                                @click="deletePages" :disabled="!numSelected()">
                            <i class="fa fa-trash"></i> Apagar Páginas
                        </button>
                    </div>
                    <div class="col-12 pt-20">
                        <button type="submit" class="btn btn-alt-primary btn-lg btn-block text-uppercase"
                                :disabled="!loading.pagesPdf && slices[selectedJob].jobCategoryPages.length === 0"
                                @click="disapproveJobs">
                            <i class="fa fa-ban"></i> Recusar Classificação
                        </button>
                    </div>
                    <div class="col-12 pt-20">
                        <button type="button" class="btn btn-alt-primary btn-lg btn-block text-uppercase"
                                @click="deleteJobs">
                            <i class="fa fa-trash"></i> Deletar Classificação
                        </button>
                    </div>
                    <div class="col-12 pt-20">
                        <button type="button" class="btn btn-alt-primary btn-lg btn-block text-uppercase"
                                :disabled="!loading.pagesPdf && slices[selectedJob].jobCategoryPages.length === 0 || slices[selectedJob].send && slices[selectedJob].received"
                                @click="approveJobs">
                            <i class="fa fa-save"></i> Aprovar Classificação
                        </button>
                    </div>
                </div>
                <div v-else>
                    <h2 class="text-center text-white"><i class="fa fa-spinner fa-spin"></i></h2>
                </div>
            </div>
        </div>
        <div class="block block-themed block-rounded shadow actions-content mb-200">
          <div class="block-header bg-gd-emerald">
            <h4 class="block-title text-center text-white">Nova classificação</h4>
          </div>
          <div class="block-content bg-primary pt-10 pb-10" v-if="!loading.slicesCategory">
            <form action="" method="post" onsubmit="return false;">
              <div class="form-group row">
                <label class="col-12 col-form-label text-white" for="classification-code"><b>Código</b></label>
                <div class="col-md-9 pr-0">
                  <input type="text" class="form-control" id="classification-code" ref="searchCode"
                         v-model="searchField" placeholder="Ex.: 001, 125.3">
                </div>
                <div class="col-md-3">
                  <button type="submit" class="btn btn-alt-primary btn-block p-0"
                          @click="searchByCode">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-12 text-white my-10">
                <b>Tipo</b>
              </div>
              <form action="" method="post" onsubmit="return false;" class="col-12">
                <div class="form-group row">
                  <div class="col-12">
                    <v-select ref="selectCategory" v-model="selected_category" :options="categories"
                              label="name" :selected="selected_category.categoryId"></v-select>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="block-content bg-primary pt-10 pb-10" v-else>
            <h2 class="text-center text-white"><i class="fa fa-spinner fa-spin"></i></h2>
          </div>
          <form action="" method="post" onsubmit="return false;">
            <div class="block-content bg-primary pt-0 pb-10">
              <div class="form-group row">
                <div class="col-12">
                  <button type="submit" ref="saveCategoryButton"
                          class="btn btn-lg btn-dark shadow-sm btn-block text-uppercase"
                          @click="createNewCategory()">
                    <i class="fa fa-plus-square"></i> Nova classificação
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal fade" ref="modalZoomImg" id="modalZoomImg" tabindex="-1" role="dialog"
         aria-labelledby="modalZoomImg" aria-hidden="true" v-if="!loading.pagesPdf">
      <div class="col-1 loadImg vertical-align mx-auto" v-if="loading.loadImg">
        <i class="fa fa-spinner fa-spin fa-4x text-white"></i>
      </div>
      <a @click="navPage('prev')" class="btn btn-lg btn-alt-primary pt-3 nav prev vertical-align pl-20 mb-50"
         data-nav="prev" data-toggle="cropper" data-method="prevPage" title="Voltar página"
         v-show="countPage !== 0">
        <i class="fa fa-angle-double-left"></i>
      </a>
      <a @click="navPage('next')" class="btn btn-lg btn-alt-primary pt-3 nav next vertical-align pl-20 mb-50"
         data-nav="next" data-toggle="cropper" data-method="nextPage" title="Avançar página"
         v-show="countPage !== slices[selectedJob].jobCategoryPages.length - 1">
        <i class="fa fa-angle-double-right"></i>
      </a>
      <div class="block-options mr-15 pull-right">
        <button type="button" class="btn-block-option btn-close" data-dismiss="modal" aria-label="Close">
          <i class="si si-close fa-3x text-white"></i>
        </button>
      </div>
      <div class="modal-dialog modal-dialog-slideup modal-lg" role="document">
        <div class="text-center">
          <img v-bind:src="linkImg" class="img-fluid" @load="imgLoaded" v-show="!loading.loadImg">
        </div>
      </div>
    </div>
    <!-- Modal Delete Page -->
    <div class="modal fade modal-md" ref="modalDeleteImg" id="modalDeleteImg" tabindex="-1" role="dialog"
         aria-labelledby="modalDeleteImg" aria-hidden="true" v-if="!loading.modalDelete">
      <div class="block-options mr-15 pull-right">
        <button type="button" class="btn-block-option btn-close" data-dismiss="modal" aria-label="Close">
          <i class="si si-close fa-3x text-white"></i>
        </button>
      </div>
      <div class="modal-dialog modal-dialog-slideup modal-lg" role="document">
        <div class="text-center">
          <img v-bind:src="linkImg" class="img-fluid" @load="imgLoaded" v-show="!loading.loadImg">
        </div>
      </div>
    </div>
    <!-- End Modal Delete Page -->
  </div>
</template>

<script>
  import selectable from 'vue-selectable';
  import api from '../lib/api';
  import config from '../config/index';
  import swal from 'sweetalert2';

  export default {
    data() {
      return {
        jobId: '',
        loading: {
          studentDetail: true,
          pagesPdf: true,
          slicesCategory: true,
          hasCategory: false,
          loadImg: false,
          additionalFields: false,
          modalDelete: false,
        },
        student: {
          name: '-',
          unity: '-',
          course: '-',
          registration: '-'
        },
        selected: [],
        selecting: [],
        selectable: [],
        selectPage: false,
        slices: [],
        selectedJob: 0,
        classJob: [],
        linkImg: '',
        pages: [],
        countPage: 0,
        itemsSliced: [],
        searchField: '',
        categories: [],
        subCategories: [],
        selected_category: 'Selecione',
        additionalFields: [],
        catFinished: '',
        subject: "",
        author: "",
        locationDateTime: "",
        digitizationResponsible: "",
        productionDate: "",
        genus: "Textual",
        listGenus: [
          "Textual",
          "Iconográfico",
          "Eletrônico",
          "Bibliográfico",
          "Cartográfico",
        ],
      }
    },
    methods: {
      getDetails() {
        this.loading.studentDetail = true;
        this.jobId = this.$route.params.id;
        api.get('/documentDetails/GetDocumentDetailByJobId/' + this.jobId)
          .then(({data}) => {
            if (data.success === true) {
              this.student = data.result;
              this.loading.studentDetail = false;
            }
          });
      },
      async getJobs(finishDossieClassificated = false) {
        this.loading.pagesPdf = true;
        this.loading.slicesCategory = true;
        api.get('/JobCategories/GetJobCategoriesByJobId?jobId=' + this.jobId)
          .then(({data}) => {
            this.slices = data.result;
            this.loading.pagesPdf = false;
            this.loading.slicesCategory = false;
            this.loadButtonJob();
            for (let num = 0; num < this.slices.length; num++) {
              this.classJob[num].selec = false;
            }
            if(this.classJob.length !== 0) {
              this.classJob[this.selectedJob].selec = true;
            }
            this.updateSubCategories(this.selectedJob);
            if(finishDossieClassificated) this.finishDossieClassificated();
          });
      },
      getCategories() {
        api.get('/categories/getCategories')
          .then(({data}) => {
            this.categories = data.result;
          });
      },
      loadButtonJob() {
        for (let num = 0; num < this.slices.length; num++) {
          this.classJob.push({
            selec: false
          })
        }
      },
      selectJob(i) {
        this.selectedJob = i;
        this.selected = [];
        this.selecting = [];
        this.selectable = [];
        this.selectPage = false;
        this.getJobs();
      },
      zoomImg(e) {
        this.loading.loadImg = true;
        this.countPage = e;
        this.linkImg = this.slices[this.selectedJob].jobCategoryPages[this.countPage].image;
        this.countPage = e;
        this.selectPage = true;
      },
      imgLoaded() {
        this.loading.loadImg = false;
        this.selectPage = false;
      },
      navPage: function (e) {
        this.loading.loadImg = true;
        if (e === "next") {
          if (this.countPage !== this.numPages - 1) {
            this.countPage++;
          } else {
            this.countPage = 0;
          }
        } else {
          if (this.countPage >= 1) {
            this.countPage--;
          } else {
            this.countPage = this.numPages - 1;
          }
        }
        this.zoom = 1;
        this.linkImg = this.slices[this.selectedJob].jobCategoryPages[this.countPage].image;
      },
      searchByCode() {
        api.get('/categories/GetCategoryBySearch?code=' + this.searchField)
          .then(({data}) => {
            this.selected_category = {
              categoryId: data.result.categoryId,
              name: data.result.name
            };
          })
          .catch(() => {
            this.loading.pagesPdf = false;
            this.selected_category = 'Selecione';
            return swal({
              title: 'Erro ao localizar Código da Categoria.',
              toast: true,
              timer: 3000,
              type: "error",
              showConfirmButton: false,
            })
          });
      },
      updateSubCategories(i) {
        try {
          if (this.slices[i].additionalFields === null || this.slices[i].additionalFields.length === 0) {
            this.loading.additionalFields = false;
          }
          else if (this.slices[this.selectedJob].additionalFields.length >= 1) {
            this.loading.additionalFields = true;
            }

            this.subject = this.slices[i].subject;
            this.author = this.slices[i].author;
            this.locationDateTime = this.slices[i].locationDateTime;
            this.digitizationResponsible = this.slices[i].digitizationResponsible;
            this.productionDate = this.slices[i].productionDate;
            this.genus = this.slices[i].genus;

        } catch(e) {
          console.log(i, e, this.slices);
        }
      },
      approveJobs() {
        this.$validator.validate().then((result) => {
          if (result) {
            let request = {
              jobCategoryId: this.slices[this.selectedJob].jobCategoryId,
              additionalFields: this.slices[this.selectedJob].additionalFields,
              subject: this.subject,
              author: this.author,
              locationDateTime: this.locationDateTime,
              digitizationResponsible: this.digitizationResponsible,
              productionDate: this.productionDate,
              genus: this.genus
            }
            return swal({
              title: 'Aprovar Classificação',
              text: 'Aprovar classificação do dossiê?',
              type: "info",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: 'Confirmar',
              cancelButtonText: 'Cancelar'
            })
              .then(result => {
                if (result.value) {
                  api.post('/JobCategories/SetJobCategoryApprove', request)
                    .then(() => {
                      this.loading.pagesPdf = false;
                      this.countPage = 0;
                      this.itemsSliced = [];
                      this.subCategories = [];
                      this.selected_category = "Selecione";
                      this.additionalFields = 0;
                      this.validateSubCategories = false;
                      this.subject = "";
                      this.author = "";
                      this.genus = "Textual";
                      this.getJobs(true);
                    })
                    .catch(() => {
                      this.loading.pagesPdf = false;
                      this.loading.slicesCategory = false;
                      return swal({
                        title: 'Erro ao aprovar classificação!',
                        toast: true,
                        timer: 3000,
                        type: "error",
                        showConfirmButton: false,
                      })
                    })
                }
              })
          } else {
            return swal({
              title: 'Dossiê não classificado',
              text: 'Preencha todos os campos obrigatórios',
              timer: 3000,
              type: "error",
            });
          }
        })
      },
      deleteJobs: function () {
        if (this.selectedJob !== '') {
          let request = {
            jobCategoryId: this.slices[this.selectedJob].jobCategoryId
          }
          return swal({
            title: 'Apagar Classificação',
            text: 'Deseja realmente excluir grupo de Classificação?',
            type: "info",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
          })
            .then(result => {
              if (result.value) {
                this.loading.pagesPdf = true;
                this.loading.slicesCategory = true;
                api.post('/JobCategories/SetJobCategoryDeleted', request)
                  .then(() => {
                    this.getJobs(true);
                    this.selectedJob = 0;
                    return swal({
                      title: 'Exclusão de grupo de classificação realizado com sucesso',
                      toast: true,
                      timer: 3000,
                      type: "success",
                      showConfirmButton: false
                    })
                  })
                  .catch(() => {
                    this.loading.pagesPdf = false;
                    this.loading.slicesCategory = false;
                    return swal({
                      title: 'Erro ao salvar recorte!',
                      toast: true,
                      timer: 3000,
                      type: "error",
                      showConfirmButton: false,
                    })
                  })
              }
            })
        } else {
          return swal({
            title: 'Nenhuma categoria selecionada',
            toast: true,
            timer: 3000,
            type: "info",
            showConfirmButton: false,
          })
        }
      },
      numSelected() {
        return this.selected.filter(e => {
          return e;
        }).length
      },
      selectedGetter() {
        return this.selected;
      },
      selectedSetter(v) {
        if (!this.selectPage) {
          this.selected = v;
        }
      },
      selectingSetter(v) {
        if (!this.selectPage) {
          this.selecting = v;
        }
      },
      deletePages: function () {
        if (this.slices[this.selectedJob].jobCategoryPages.length !== 0) {

          let jobCategoryPages = [];
          this.slices[this.selectedJob].jobCategoryPages.map((page, index) => {
            let isSelected = this.selected[index];
            if (isSelected) {
              jobCategoryPages.push({jobCategoryPageId: page.jobCategoryPageId});
            }
          });
          
          let request = {
            jobCategoryPages
          };

          console.log(request)

          return swal({
            title: 'Apagar Página?',
            text: 'Deseja realmente apagar a(s) página(s) digitalizada(s)?',
            type: "info",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
          })
            .then(result => {
              if (result.value) {
                this.loading.pagesPdf = true;
                this.loading.slicesCategory = true;
                api.post('/JobCategoryPages', request)
                  .then(({data}) => {
                    this.getJobs(true);
                    this.selectedJob = this.selectedJob;
                    return swal({
                      title: 'Exclusão da página digitalizada realizado com sucesso',
                      toast: true,
                      timer: 3000,
                      type: "success",
                      showConfirmButton: false
                    })
                  })
                  .catch(() => {
                    this.loading.pagesPdf = false;
                    this.loading.slicesCategory = false;
                    return swal({
                      title: 'Erro ao excluir página!',
                      toast: true,
                      timer: 3000,
                      type: "error",
                      showConfirmButton: false,
                    })
                  })
              }
            })
        }
      },
      disapproveJobs: function () {
        if (this.selectedJob !== '') {
          let request = {
            jobCategoryId: this.slices[this.selectedJob].jobCategoryId
          }
          return swal({
            title: 'Desaprovar Dossiê?',
            text: 'Deseja realmente desaprovar grupo de Dossiê?',
            type: "info",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
          })
            .then(result => {
              if (result.value) {
                this.loading.pagesPdf = true;
                this.loading.slicesCategory = true;
                api.post('/JobCategories/SetJobCategoryDisapprove', request)
                  .then(() => {
                    return swal({
                      title: 'Grupo de Dossiê desaprovado com sucesso',
                      toast: true,
                      timer: 3000,
                      type: "success",
                      showConfirmButton: false
                    })
                      .then(() => {
                        this.getJobs(true);
                      })
                  })
                  .catch(() => {
                    this.loading.pagesPdf = false;
                    this.loading.slicesCategory = false;
                    return swal({
                      title: 'Erro excluir Dossiê!',
                      toast: true,
                      timer: 3000,
                      type: "error",
                      showConfirmButton: false,
                    })
                  })
              }
            });
        } else {
          return swal({
            title: 'Nenhuma categoria selecionada',
            toast: true,
            timer: 3000,
            type: "info",
            showConfirmButton: false,
          })
        }
      },
      createNewCategory() {
        let request = {
          jobId: this.jobId,
          categoryId: this.selected_category.categoryId
        };

        if (this.selected_category === "Selecione") {
          return swal({
            title: 'Selecione uma categoria para adicionar',
            toast: true,
            timer: 3000,
            type: "info",
            showConfirmButton: false,
          })
        }
        for (let i = 0; i < this.slices.length; i++) {
          if (this.categoryName === this.slices[i].category) {
            this.loading.hasCategory = true;
            break;
          } else {
            this.loading.hasCategory = false;
          }
        }
        if (!this.loading.hasCategory) {
          return swal({
            title: 'Envio de Novo Grupo',
            text: 'Deseja realmente incluir nova classificação?',
            type: "question",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
          })
            .then(result => {
              if (result.value) {
                this.loading.pagesPdf = true;
                this.loading.slicesCategory = true;
                api.post('/JobCategories/SetJobCategoryInclude', request)
                  .then(() => {
                    return swal({
                      title: 'Inclusão de nova classificação realizado com sucesso',
                      toast: true,
                      timer: 3000,
                      type: "success",
                      showConfirmButton: false
                    })
                      .then(() => {
                        this.getJobs();
                      })
                  })
                  .catch(() => {
                    this.loading.pagesPdf = false;
                    this.loading.slicesCategory = false;
                    return swal({
                      title: 'Erro ao salvar classificação!',
                      toast: true,
                      timer: 3000,
                      type: "error",
                      showConfirmButton: false,
                    })
                  })
              }
            })
        } else {
          return swal({
            text: 'Classificação já existe',
            toast: true,
            timer: 3000,
            type: "error",
            showConfirmButton: false,
          })
        }
      },
      finishDossieClassificated() {
        let numCategories = this.slices.length;
        this.catFinished = 0;
        for (let i = 0; i < numCategories; i++) {
          if (this.slices[i].received && this.slices[i].send) {
            this.catFinished++;
          }
        }

        if (this.catFinished === numCategories) {
          let request = {
            jobId: this.jobId,
            jobStatusId: 4
          };
          api.post('/Jobs/SetJobStatus', request)
            .then(() => {
              return swal({
                title: 'Classificação de Dossiê finalizado com sucesso',
                toast: true,
                timer: 3000,
                type: "success",
                showConfirmButton: false
              })

                .then(() => {
                  swal.close();
                  this.$router.push('/scanned');
                })
            })
            .catch(() => {
              this.loading.pagesPdf = false;
              this.loading.slicesCategory = false;
              return swal({
                title: 'Erro ao finalizar Dossiê',
                toast: true,
                timer: 3000,
                type: "error",
                showConfirmButton: false,
              })
            })
        }
      }
    },
    directives: {
      selectable
    },
    mounted() {
      this.getDetails();
      this.getJobs();
      this.getCategories();
    },
    watch: {
      selected_category(newVal) {
        if (newVal === 'Selecione' || newVal === null) {
          this.subCategories = [];
          this.selected_category = 'Selecione';
          this.additionalFields = 0;
        } else {
          this.categoryId = newVal.categoryId;
          this.categoryName = newVal.name;
        }
        this.searchField = '';
      }
    }
  }
</script>
